import countries from 'i18n-iso-countries'

import {useLocale} from '@/providers/locale'

import type {CountryCode} from '@/locale/locales'

/**
 * Returns a function which, when called with a country code, returns the name
 * of the country in the language of the current page locale.
 */

export const useGetCountryName = () => {
    const locale = useLocale()

    countries.registerLocale(require(`i18n-iso-countries/langs/${locale.language}.json`))

    return (countryCode: CountryCode) =>
        countries.getName(countryCode, locale.language) || locale.countryName
}
